import React, { useState } from 'react';
import PropTypes from 'prop-types';
import isString from 'lodash/isString';
import { Title } from '@lib/components/v2/Title';
import Page from '@lib/components/v2/Page';
import { Checkbox } from '@lib/components/v2/Form';
import { localizedString } from '@languages';

import parse from 'html-react-parser';
import classes from './Privacy.style.module.scss';

const Privacy = ({ privacyContent, onAccept, onSelectLanguage, hidePrivacyCheckBox, flowType }) => {
  const [isPrivacyAccepted, setIsPrivacyAccepted] = useState(false);
  const { backurl } = document.body.dataset;

  const isContinueButtonEnabled = hidePrivacyCheckBox || isPrivacyAccepted;
  const buttons = [
    {
      label: localizedString('continue'),
      disabled: !isContinueButtonEnabled,
      onClick: () => {
        if (isContinueButtonEnabled) {
          onAccept();
        }
      },
      dataTestId: 'privacy-continue'
    }
  ];

  if (backurl) {
    buttons.unshift({
      label: localizedString('back'),
      variant: 'transparent',
      onClick: () => {
        window.location.href = backurl;
      }
    });
  }

  let privacyContentElements;
  if (!privacyContent) {
    let privacyContents = [];
    if (flowType === 'VOI_FLOW_V2') {
      privacyContents = localizedString('privacy.voiV2Content') || [];
    }
    if (privacyContents.length === 0) {
      privacyContents = localizedString('privacy.flowV2Content') || [];
    }
    privacyContentElements = privacyContents.map((item, index) => {
      return (
        // eslint-disable-next-line react/no-array-index-key
        <div key={index} data-testid={`privacy-consent-${index}`}>
          {parse(item)}
          <br />
          <br />
        </div>
      );
    });
  } else {
    privacyContentElements = isString(privacyContent) ? parse(privacyContent) : privacyContent;
  }

  return (
    <Page isPrivacy buttons={buttons} onSelectLanguage={onSelectLanguage}>
      <Title data-testid="privacy-heading" title={localizedString('privacy.flowV2Title')} />
      <div className={classes.content}>
        {privacyContentElements}

        {!hidePrivacyCheckBox && (
          <Checkbox
            id="confirm"
            value={isPrivacyAccepted}
            onChange={(value) => setIsPrivacyAccepted(value)}
            label={localizedString('privacy.flowV2CheckBox')}
            dataTestId="privacy-chkBx"
            labelDataTestId="privacy-consentTxt"
          />
        )}
      </div>
    </Page>
  );
};

Privacy.propTypes = {
  onAccept: PropTypes.func,
  privacyContent: PropTypes.any,
  onSelectLanguage: PropTypes.func,
  hidePrivacyCheckBox: PropTypes.bool,
  flowType: PropTypes.string
};

export default Privacy;
